import type { ConfigObj } from "./Configuration";
import { Role } from "./Role";

export const DojoIslandsConfigurations: Record<Role, ConfigObj> = {
  [Role.STUDENT_USER]: {
    STARTUP_SPAWN_LOCATION: "OWN_PLOT",
  },
  [Role.TEACHER_USER]: {
    STARTUP_SPAWN_LOCATION: "OWN_PLOT",
  },
  [Role.ANONYMOUS_GUEST_USER]: {
    STARTUP_SPAWN_LOCATION: "INVITER_PLOT_MAILBOX",
  },
  [Role.PUBLIC_GUEST_USER]: {
    STARTUP_SPAWN_LOCATION: "INVITER_PLOT_MAILBOX",
  },
  [Role.VISITOR_GUEST_USER]: {
    STARTUP_SPAWN_LOCATION: "INVITER_PLOT_MAILBOX",
  },
  [Role.VIP_GUEST_USER]: {
    STARTUP_SPAWN_LOCATION: "OWN_PLOT",
  },
};
